import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { detect } from "detect-browser";
import { Link, useNavigate } from "react-router-dom";

import { useCookies } from "react-cookie";
import { ToastContainer } from "react-toastify";
import { getAdminDetailsThunk } from "USERPROFILE/supportSlice";
// import useAdminHelperFunction from "../CustomHooks/useAdminHelperFunction";
import {
  postLoginThunk,
  setCompanyNumber,
  getClientThunk,
  resetLoginData,
  // setuserPrivilege,
  // getuserPrivileges,
  // getUIAppUserAttributes,
  getIacRejectToLogin,
  // clearSSOMsg,
  logUserDetails,
} from "../redux/features/loginSlice";

import { setApiMessage } from "../redux/features/globalApiMessageSlice";
import useIdentifySsoClient from "../SSOClientsData/useIdentifySsoClient";
import { CLIENT_SETUP_IAC } from "../ClientSetupIac";

export const Login = () => {
  const clientData = useIdentifySsoClient();
  // console.log(clientData, "clientData from login js");
  const [isCapsLockOn, setIsCapsLockOn] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [cookies, setCookie] = useCookies();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(true);
  let navigate = useNavigate();
  const loginContainerRef = useRef();
  const dispatch = useDispatch();
  // const search = useLocation().search;
  const login = useSelector((state) => state.login);
  const { currentPrivilege = [] } = login;

  const { adminData } = useSelector((state) => state.support);
  // const { user } = useSelector((state) => state.accountManage);
  const [adminText, setAdminText] = useState({});
  const [WelcomeMessageField, setWelcomeMessageField] = useState({});
  const { enableIACCheckonLogin } = CLIENT_SETUP_IAC;

  const clientApiCall = async () => {
    const response = await dispatch(getClientThunk());
    if (response) {
      console.log(response,'companyNumber')
      const adminData = await dispatch(getAdminDetailsThunk());
      const loginMessageData =
        adminData?.payload?.headerLinks?.login_welcome_message || {};
      let loginText = adminData?.payload?.headerLinks?.appName || {};
      setWelcomeMessageField({
        ...loginMessageData,
        showField:
          loginMessageData?.fieldVisible == "true"
            ? true
            : loginMessageData?.fieldVisible == "false"
            ? false
            : loginMessageData?.fieldVisible == "NA"
            ? loginMessageData?.defaultFieldVisible == "true"
              ? true
              : false
            : true,
      });
      setAdminText({
        ...loginText,
        showField:
          loginText?.fieldVisible == "true"
            ? true
            : loginText?.fieldVisible == "false"
            ? false
            : loginText?.fieldVisible == "NA"
            ? loginText?.defaultFieldVisible == "true"
              ? true
              : false
            : true,
      });
    }
  };

  useEffect(() => {
    dispatch(setApiMessage({ status: "", message: "" }));
    clientApiCall();
    // login userinfo call
    setErrorMsg("");
    if (!login.currentRoute && !login.ssoErrorMessage) {
      dispatch(resetLoginData());
    }
  }, []);

  const onRememberMeClick = () => {
    const isRememberValue = !rememberMe;
    setRememberMe(isRememberValue);
  };

  useEffect(() => {
    const { headerLinks: { orderSearch = {} } = {} } = adminData;
    const isAccessToOrderSearch =
      orderSearch?.fieldVisible == "true" &&
      orderSearch?.fieldKey &&
      currentPrivilege.includes("Order Search")
        ? true
        : false;

    const navigateTo =
      sessionStorage.getItem("preselect") == "true" ||
      (sessionStorage.getItem("isOrderDetailDirectLink") == "true" &&
        !isAccessToOrderSearch)
        ? "/searchResults"
        : isAccessToOrderSearch &&
          sessionStorage.getItem("isOrderDetailDirectLink") == "true"
        ? `/orderDetailData/${+sessionStorage.getItem("orderNumber")}`
        : "/home";

    let isNewUser = login?.userInfoAttr?.redirectUsertoPasswordReset || false;
    let uatEnv = window.location.host.includes("uat");

    const envs = ["qa", "uat", "localhost", "dev"];

    localStorage.removeItem("AppName");

    const prodSsoLoginByEnv = envs.every(
      (e) => !window.location.host.includes(e)
    );

    console.log(prodSsoLoginByEnv, "prodSsoLoginByEnv from login.js");
    let iacCheckMerck =
      login.userInfoAttr?.userInfo?.companyNumber == "0831"
        ? login.isActiveIacUser
        : true;

    if (login.apiStatusCode && login.apiStatusCode === 200 && iacCheckMerck) {
      if (login.currentRoute) {
        // navigate(login.currentRoute);
        if (isNewUser) {
          navigate(
            `/reset-password?appUserId=${login.userInfoAttr?.userInfo?.appUserId}&t=${login?.token}`
          );
        } else {
          navigate(navigateTo);
        }
      } else {
        if (isNewUser) {
          navigate(
            `/reset-password?appUserId=${login.userInfoAttr?.userInfo?.appUserId}&t=${login?.token}`
          );
        } else {
          navigate(navigateTo);
        }
      }

      setCookie("token", login.data, {
        path: "*",

        expires: new Date(Date.now() + 300000000),
      });
    } else if (
      login &&
      login.data &&
      login.data.status < 500 &&
      login.data.status > 399
    ) {
      if (!login.isSsoLoginUser) {
        setErrorMsg(login.data?.message);
      }
    } else if (
      login &&
      login.apiStatusCode &&
      login.apiStatusCode === 200 &&
      !iacCheckMerck
    ) {
      setErrorMsg(login.message);
    } else if (login.isSsoLoginUser) {
      setErrorMsg(null);
    } else if (
      uatEnv &&
      !login.apiStatusCode &&
      login.apiStatusCode != 200 &&
      window.location.pathname === "/"
    ) {
      if (clientData?.isSsoClient) {
        //window.location.replace("https://securet.hibbertgroup.com/sso/sp/startSSO.ping?PartnerIdpId=https%3A%2F%2Fpingfed-ut.merck.com%2Fsaml2%2Fidp")
        // window.location.replace(
        //   "https://securet.hibbertgroup.com/sso/sp/startSSO.ping?PartnerIdpId=https%3A%2F%2Fpingfed-ut.merck.com%2Fsaml2%2Fidp"
        // );
        window.location.replace(clientData?.ssoUatUrl);
      }
    } else if (
      prodSsoLoginByEnv &&
      !login.apiStatusCode &&
      login.apiStatusCode != 200 &&
      window.location.pathname === "/"
    ) {
      if (clientData?.isSsoClient) {
        // window.location.replace(
        //   "https://securep.hibbertgroup.com/sso/sp/startSSO.ping?PartnerIdpId=https%3A%2F%2Fpingfed.merck.com%2Fsaml2%2Fidp"
        // );
        window.location.replace(clientData?.ssoProdUrl);
      }
    } else {
      navigate("/login");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [login]);

  const onSignIn = async () => {
    const browser = detect();

    const appId = process.env.REACT_APP_APP_ID;

    let companyNumber = login.companyNumber;

    dispatch(setCompanyNumber(companyNumber));

    const {
      appCodeName,

      appName,

      appVersion,

      connection: { downlink, effectiveType } = {},

      deviceMemory,

      hardwareConcurrency,

      language,

      product,

      productSub,

      userAgent,

      userAgentData: { brands = [], mobile, platform } = {},
    } = navigator;

    //#region saved user agent logs

    const errorDetailPayload = {
      errorDetailPage: window.location.pathname.substring(1),
      errorDetailUrl: window.location.href,

      errorDetailPayload: {
        browser,

        userAgent,

        platform,

        appVersion,

        appName,

        username,

        companyNumber,

        appId,

        appCodeName,

        downlink,

        effectiveType,

        deviceMemory,

        hardwareConcurrency,

        language,

        product,

        productSub,

        brands,

        mobile,
      },

      errorDetailResponse: "",

      userName: username,

      companyNumber: companyNumber,

      recordType: "Info",

      errorType: "Info",
    };

    dispatch(logUserDetails(errorDetailPayload));
    //#endregion saved user agent logs

    dispatch(
      postLoginThunk({
        username,

        appId,

        companyNumber,

        divisionNumber: "1000",

        password,
        sessionTimeoutInMin: "480",
        // sessionTimeoutInMin: "1440",
        // sessionTimeoutInMin: "2",
      })
    ).then((response) => {
      const iacPayload = {
        iac: response?.payload?.userInfo?.userInfo?.userAttributes?.iac,

        userInfo: response?.payload?.userInfo?.userInfo,
      };
      if (enableIACCheckonLogin?.includes(companyNumber)) {
        dispatch(getIacRejectToLogin(iacPayload));
      }
    });
  };

  const onKeyDown = (keyEvent) => {
    console.log(keyEvent.getModifierState("CapsLock"), ">>>>");

    if (keyEvent.getModifierState("CapsLock")) {
      setIsCapsLockOn(true);
    } else {
      setIsCapsLockOn(false);
    }

    submitOnEnter(keyEvent);
  };

  const submitOnEnter = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();

      if (username.trim() && password.trim()) {
        onSignIn();
      }
    }
  };

  //Footer from admin
  const [footerData, setFooterData] = useState({});

  useEffect(() => {
    if (adminData?.headerLinks?.siteFooter) {
      setFooterData({ ...adminData.headerLinks.siteFooter });
    }
  }, [adminData]);

  return (
    <main role="main" className="main login-body" ref={loginContainerRef}>
      {/* <GlobalMessage /> */}

      <ToastContainer />

      <div className="container">
        <article className="login-card shadow-1 center2">
          <div className="group login-contain">
            <>
              <div className="span5 mobile-hide sign-up">
                <div className="welcome-content">
                  <h1>Welcome!</h1>
                  <br></br>
                  {/* <span className="login-sub-title">Create Your Account</span> */}
                  {WelcomeMessageField?.showField ? (
                    <p className="welcome-text">
                      {WelcomeMessageField?.clientSpecificLabel ||
                        WelcomeMessageField?.defaultLabel}
                    </p>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              <div className="span7 login-content">
                {login?.ssoErrorMessage ? (
                  <div className="alert-danger text-center">
                    <div style={{ textAlign: "center" }}>
                      <strong>Single Sign-On Error!</strong>
                      <br />
                      <br />
                      {login?.ssoErrorMessage}
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div className="logo" id="logo"></div>
                <h1 className="h1-nbold">
                  Sign in to the<br></br>
                  {console.log(adminText, "lsdkjfsdl")}
                  {adminText?.showField ? (
                    <strong>
                      {adminText?.clientSpecificLabel ||
                        adminText?.defaultLabel}
                    </strong>
                  ) : (
                    ""
                  )}
                  {/* {loginPageText?.showField ? <strong>Sales Service Portal</strong> : ""} */}
                </h1>
                <br></br>
                {isCapsLockOn ? (
                  <div className="error" style={{ textAlign: "center" }}>
                    Warning: CapsLock is On
                  </div>
                ) : (
                  <div className="error" style={{ height: "15px" }}>
                    {" "}
                  </div>
                )}
                <div>
                  <input
                    id="email"
                    className={`${
                      errorMsg && errorMsg.length ? "error-border" : ""
                    }`}
                    autoFocus
                    value={username}
                    onKeyDown={submitOnEnter}
                    onChange={(e) => {
                      setUsername(e.target.value);
                      setErrorMsg(null);
                    }}
                    placeholder="&#xf0e0; Username"
                    type="text"
                  />
                </div>
                <div style={{ marginBottom: "20px" }}>
                  <input
                    id="password"
                    className={`${
                      errorMsg && errorMsg.length ? "error-border" : ""
                    }`}
                    onKeyDown={onKeyDown}
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setErrorMsg(null);
                    }}
                    placeholder="&#xf023; Password"
                    type="password"
                  />

                  {errorMsg && errorMsg.length ? (
                    <div className="error">{errorMsg}</div>
                  ) : (
                    <div className="error" style={{ height: "15px" }}>
                      {" "}
                    </div>
                  )}
                </div>
                <div style={{ margin: "0 auto", paddingBottom: "30px" }}>
                  <label htmlFor="rememberMe">
                    {" "}
                    <input
                      type="checkbox"
                      checked={rememberMe}
                      id="rememberMe"
                      onChange={onRememberMeClick}
                    />{" "}
                    Remember me
                  </label>
                </div>{" "}
                <Link to="/confirmEmail">Forgot your password</Link>
                <div style={{ margin: "0 auto", paddingTop: "30px" }}>
                  <button
                    id="signIn"
                    disabled={!username.trim() || !password.trim()}
                    onClick={onSignIn}
                    className={`${
                      !username.trim() || !password.trim()
                        ? "btn-disabled"
                        : "btn-primary"
                    } btn text-center`}
                  >
                    SIGN IN{" "}
                    {login.loading === true && (
                      <i className="fa fa-spinner fa-pulse fa-lg fa-fw"></i>
                    )}
                  </button>
                </div>
                <div className="login-footer">
                  <br />
                  <div className="margin-top3">
                    <footer>
                      <div
                        className="container"
                        dangerouslySetInnerHTML={{
                          __html:
                            footerData?.clientSpecificLabel ||
                            footerData?.defaultLabel,
                        }}
                      ></div>
                    </footer>
                  </div>
                </div>
              </div>
            </>
          </div>
        </article>
      </div>
    </main>
  );
};
